<template>
  <div class="login EnableClient">

    <section id="servicios" class="secciones seccion-blanca">
      <div class="row justify-content-center">
            <div :class="[(mensaje === '') ? 'd-none' : 'col-sm-12']" >
              <h2><strong>{{ mensaje }}</strong></h2> 
              <br>
              <br>
              <a href data-toggle="modal" class="btn btn-info" data-target="#myModal2">Iniciar Sesión</a>
            </div>
            <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert">
              <button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button>
              <strong>{{ mensaje_error }}</strong>
            </div>
      </div>
    </section>
    <TwoModules></TwoModules>
    <News></News>
  </div>
</template>
<script>
import TwoModules from "@/components/products/TwoModules.vue";
import News from "@/components/products/Guia.vue";
import axios from "axios";
import { mapState, mapActions, mapMutations } from "vuex";
import { encryptUser } from "@/components/shared/service/authService";
import {
  successToaster,
  errorToaster
} from "@/components/shared/service/ErrorHandler.js";
import { config_settings } from "@/config.js";

//HTTP ERROR STATUS
const NOT_FOUND = 404;
const BAD_REQUEST = 400;
const UNAUTHORIZED = 401;
const CONFLICT = 409;
const INTERNAL_SERVER_ERROR = 500;

export default {
  name: "login",
  components: { TwoModules, News },
  data() {
    return {
      username_form: this.$route.params.email,
      mensaje: "",
      mensaje_error: "",
     
    };
  },
  methods: {
   

    enable_client() {
      if (this.username_form == "") {
        this.mensaje_error = "Debe enviar un email como parámetro.";
      } else {
        var json_data = {
          cli_username: this.username_form
        };

        axios({
          method: "PUT",
          url: config_settings.RESOURCE_SERVER_URL + "/PUT/clients/enabled",
          data: json_data
        })
          .then(response => {
            this.mensaje =
              "¡Exito! Su usuario fue habilitado correctamente. Ahora puede iniciar sesión";
            /*toastr.success('¡Exito! Su contraseña ha sido restablecida correctamente. Por favor, verifique su correo electrónico asociado a esta cuenta y recomendamemos encarecidamente que cambie la contraseña generada.', 
                        "ÉXITO", {"iconClass": 'customer-success'}); */
          })
          .catch(error => {
            console.log("hOLA:" + error);
            this.mensaje = "";
            this.mensaje_error =
              "Hubo un problema al activar su usuario. Verifique su e-mail e intentelo nuevamente.";
            /*toastr.error(error.response.data.details,
                      error.response.data.message,
                      {"iconClass": 'customer-danger'});*/
          });
      }
    },

    ocultar() {
      this.mensaje = "";
      this.mensaje_error = "";
    }
  },

  created(){
    this.enable_client()
  }
};
</script>

<style lang="scss" src="./EnableClient.scss"></style>
